import { defaultProps as AirAccordionListWidget } from './components/accordion-list-widget/stories/AccordionListWidgetDefaultProps';
import { defaultProps as AirAccordionSection } from './components/accordion-section/stories/AccordionSectionDefaultProps';
import { defaultProps as AirAcknowledgementWidget } from './components/acknowledgement-widget/stories/AcknowledgementWidgetDefaultProps';
import { defaultProps as AirAddOnWidget } from './components/add-on-widget/stories/AddOnWidgetDefaultProps';
import { defaultProps as AirAnchoredActionWidget } from './components/anchored-action-widget/stories/AnchoredActionWidgetDefaultProps';
import { defaultProps as AirBenefitWidget } from './components/benefit-widget/stories/BenefitWidgetDefaultProps';
import { defaultProps as AirBillingListWidget } from './components/billing-list-widget/stories/BillingListWidgetDefaultProps';
import { defaultProps as AirBlogCardWidget } from './components/blog-card-widget/stories/BlogCardWidgetDefaultProps';
import { defaultProps as AirBreadCrumbWidget } from './components/breadcrumb-widget/stories/BreadCrumbWidgetDefaultProps';
import { defaultProps as AirButtonWidget } from './components/button-widget/stories/ButtonWidgetDefaultProps';
import { defaultProps as AirCalloutWidget } from './components/callout-widget/stories/CalloutWidgetDefaultProps';
import { defaultProps as AirCampaignWidget } from './components/campaign-widget/stories/CampaignWidgetDefaultProps';
import { defaultProps as AirCardTitleWidget } from './components/card-title-widget/stories/CardTitleWidgetDefaultProps';
import { defaultProps as AirCarouselWidget } from './components/carousel-widget/stories/CarouselWidgetDefaultProps';
import { defaultProps as AirCheckboxGroupWidget } from './components/checkbox-group-widget/stories/CheckboxGroupWidgetDefaultProps';
import { defaultProps as AirChoronologicalListWidget } from './components/choronological-list-widget/stories/ChoronologicalListWidgetDefaultProps';
import { defaultProps as AirCollapsibleOfferListWidget } from './components/collapsible-offer-list-widget/stories/CollapsibleOfferListWidgetDefaultProps';
import { defaultProps as AirCommonMobilityStepCardWidget } from './components/common-mobility-step-card-widget/stories/CommonMobilityStepCardWidgetDefaultProps';
import { defaultProps as AirComparisonViewCardWidget } from './components/comparison-view-card-widget/stories/ComparisionViewCardWidgetDefaultProps';
import { defaultProps as AirContactDetailFormWidget } from './components/contact-detail-form-widget/stories/ContactDetailFormWidgetDefaultProps';
import { defaultProps as AirCounterWidget } from './components/counter-widget/stories/CounterWidgetDefaultProps';
import { defaultProps as AirDateTimePickerWidget } from './components/date-time-picker-widget/stories/DateTimePickerDefaultProps';
import { defaultProps as AirDropdownWidget } from './components/dropdown-widget/stories/DropdownWidgetDefaultProps';
import { defaultProps as AirDynamicScrollListWidget } from './components/dynamic-scroll-list-widget/stories/DynamicScrollListWidgetDefaultProps';
import { defaultProps as AirFormWidget } from './components/form-widget/stories/FormWidgetDefaultProps';
import { defaultProps as AirGenericSection } from './components/generic-section/stories/GenericSectionDefaultProps';
import { defaultProps as AirGraphWidget } from './components/graph-widget/stories/GraphWidgetDefaultProps';
import { defaultProps as AirIconButtonGroupWidget } from './components/icon-button-group-widget/stories/IconButtonGroupWidgetDefaultProps';
import { defaultProps as AirImageBannerWidget } from './components/image-banner-widget/stories/ImageBannerWidgetDefaultProps';
import { defaultProps as AirImageWidget } from './components/image-widget/stories/ImageWidgetDefaultProps';
import { defaultProps as AirInfoListWidget } from './components/info-list-widget/stories/InfoListWidgetDefaultProps';
import { defaultProps as AirInfoSummaryWidget } from './components/info-summary-widget/stories/InfoSummaryWidgetDefaultProps';
import { defaultProps as AirInformationBannerWidget } from './components/information-banner-widget/stories/InformationBannerWidgetDefaultProps';
import { defaultProps as AirInputWidget } from './components/input-widget/stories/InputWidgetDefaultProps';
import { defaultProps as AirKeyPairUnitWidget } from './components/key-pair-unit-widget/stories/KeyPairUnitWidgetDefaultProps';
import { defaultProps as AirLinkListItemWidget } from './components/link-list-item-widget/stories/LinkListItemWidgetDefaultProps';
import { defaultProps as AirListWidget } from './components/list-widget/stories/ListWidgetDefaultProps';
import { defaultProps as AirModalSectionWidget } from './components/modal-section/stories/ModalSectionDefaultProps';
import { defaultProps as AirNavbarWidget } from './components/navbar-widget/stories/NavbarWidgetDefaultProps';
import { defaultProps as AirOfferCardWidget } from './components/offer-card-widget/stories/OfferCardWidgetDefaultProps';
import { defaultProps as AirOfferContextualStripWidget } from './components/offer-contextual-strip-widget/stories/OfferContextualStripWidgetDefaultProps';
import { defaultProps as AirOfferListWidget } from './components/offer-list-widget/stories/OfferListWidgetDefaultProps';
import { defaultProps as AirOfferPopupWidget } from './components/offer-popup-widget/stories/OfferPopupWidgetDefaultProps';
import { defaultProps as AirOfferStripWidget } from './components/offer-strip-widget/stories/OfferStripWidgetDefaultProps';
import { defaultProps as AirOmniWidget } from './components/omni-widget/stories/OmniWidgetDefaultProps';
import { defaultProps as AirOrderSummaryCardWidget } from './components/order-summary-card-widget/stories/OrderSummaryCardWidgetDefaultProps';
import { defaultProps as AirOtpWidget } from './components/otp-widget/stories/OtpWidgetDefaultProps';
import { defaultProps as AirPackAmountWidget } from './components/pack-amount-widget/stories/PackAmountWidgetDefaultProps';
import { defaultProps as AirPackCardWidget } from './components/pack-card-widget/stories/PackCardWidgetDefaultProps';
import { defaultProps as AirPackDetailsListItemWidget } from './components/pack-details-list-item-widget/stories/PackDetailsListItemWidgetDefaultProps';
import { defaultProps as AirPackDetailsWidget } from './components/pack-details-widget/stories/PackDetailsWidgetDefaultProps';
import { defaultProps as AirPageHeaderWidget } from './components/page-header-widget/stories/PageHeaderWidgetDefaultProps';
import { defaultProps as AirPayCategoryCardWidget } from './components/pay-category-card-widget/stories/PayCategoryCardWidgetDefaultProps';
import { defaultProps as AirPlanDetailsWidget } from './components/plan-details-widget/stories/PlanDetailsWidgetDefaultProps';
import { defaultProps as AirPlanDetailsWithCarouselWidget } from './components/plan-details-with-carousel-widget/stories/PlanDetailsWithCarouselWidgetDefaultProps';
import { defaultProps as AirPlanListWidget } from './components/plan-list-widget/stories/PlanListWidgetDefaultProps';
import { defaultProps as AirPriceBreakupWidget } from './components/price-breakup-widget/stories/PriceBreakupWidgetDefaultProps';
import { defaultProps as AirPriceDetailWidget } from './components/price-detail-widget/stories/PriceDetailWidgetDefaultProps';
import { defaultProps as AirQuickActionsCardWidget } from './components/quick-actions-card-widget/stories/QuickActionsCardWidgetDefaultProps';
import { defaultProps as AirQuickFilterWidget } from './components/quick-filter-widget/stories/QuickFilterWidgetDefaultProps';
import { defaultProps as AirRadioGroupWidget } from './components/radio-group-widget/stories/RadioGroupWidgetDefaultProps';
import { defaultProps as AirReviewWidget } from './components/review-widget/stories/ReviewWidgetDefaultProps';
import { defaultProps as AirSchedulingWidget } from './components/scheduling-widget/stories/SchedulingWidgetDefaultProps';
import { defaultProps as AirScrollLinkListWidget } from './components/scroll-link-list-widget/stories/ScrollLinkListWidgetDefaultProps';
import { defaultProps as AirSelectionListWidget } from './components/selection-list-widget/stories/SelectionListWidgetDefaultProps';
import { defaultProps as AirServiceCardWidget } from './components/service-card-widget/stories/ServiceCardWidgetDefaultProps';
import { defaultProps as AirStatusCardWidget } from './components/status-card-widget/stories/StatusCardWidgetDefaultProps';
import { defaultProps as AirStepCardSection } from './components/step-card-section/stories/StepCardSectionDefaultProps';
import { defaultProps as AirStepCardWidget } from './components/step-card-widget/stories/StepCardWidgetDefaultProps';
import { defaultProps as AirTabContainerWidget } from './components/tab-container-widget/stories/TabContainerWidgetDefaultProps';
import { defaultProps as AirTableWidget } from './components/table-widget/stories/TableWidgetDefaultProps';
import { defaultProps as AirTabsWidget } from './components/tabs-widget/stories/TabsWidgetDefaultProps';
import { defaultProps as AirTaskCardWidget } from './components/task-card-widget/stories/TaskCardDefaultProps';
import { defaultProps as AirTermsAndConditionWidget } from './components/terms-and-condition-widget/stories/TermsAndConditionWidgetDefaultProps';
import { defaultProps as AirTestimonialsWidget } from './components/testimonial-widget/stories/TestimonialsWidgetDefaultProps';
import { defaultProps as AirTitleSection } from './components/title-section/stories/TitleSectionDefaultProps';
import { defaultProps as AirToastWidget } from './components/toast-widget/stories/ToastWidgetDefaultProps';
import { defaultProps as AirTrackOrderCardWidget } from './components/track-order-card-widget/stories/TrackOrderCardWidgetDefaultProps';
import { defaultProps as AirTrackOrderIngressWidget } from './components/track-order-ingress-widget/stories/TrackOrderIngressWidgetDefaultProps';
import { defaultProps as AirTrackOrderStepperWidget } from './components/track-order-stepper-widget/stories/TrackOrderStepperWidgetDefaultProps';
import { defaultProps as AirTrackingDetailedWidget } from './components/tracking-detailed-widget/stories/TrackingDetailedWidgetDefaultProps';
import { defaultProps as AirTrustMarkerWidget } from './components/trust-marker-widget/stories/TrustMarkerWidgetDefaultProps';
import { defaultProps as AirTypographyWidget } from './components/typography-widget/stories/TypographyWidgetDefaultProps';
import { defaultProps as AirUploadFileWidget } from './components/upload-file-widget/stories/UploadFileWidgetDefaultProps';
import { defaultProps as AirUpsellNudgetWidget } from './components/upsell-nudget-widget/stories/UpsellNudgeWidgetDefaultProps';
import { defaultProps as AirVerticalFluidGridSection } from './components/vertical-fluid-grid-section/stories/VerticalFluidGridSectionDefaultProps';
import { defaultProps as AirCollapsibleSummaryCardWidget } from './components/collapsible-summary-card-widget/stories/CollapsibleSummaryCardWidgetDefaultProps';
export var widgetDefaultProps = {
  AirAccordionListWidget,
  AirAccordionSection,
  AirAddOnWidget,
  AirAcknowledgementWidget,
  AirAnchoredActionWidget,
  AirBenefitWidget,
  AirBillingListWidget,
  AirBlogCardWidget,
  AirBreadCrumbWidget,
  AirButtonWidget,
  AirCalloutWidget,
  AirCampaignWidget,
  AirCardTitleWidget,
  AirCarouselWidget,
  AirCheckboxGroupWidget,
  AirChoronologicalListWidget,
  AirCollapsibleOfferListWidget,
  AirCommonMobilityStepCardWidget,
  AirComparisonViewCardWidget,
  AirContactDetailFormWidget,
  AirCounterWidget,
  AirDateTimePickerWidget,
  AirDropdownWidget,
  AirDynamicScrollListWidget,
  AirFormWidget,
  AirGenericSection,
  AirGraphWidget,
  AirIconButtonGroupWidget,
  AirImageBannerWidget,
  AirImageWidget,
  AirInfoListWidget,
  AirInfoSummaryWidget,
  AirInformationBannerWidget,
  AirInputWidget,
  AirKeyPairUnitWidget,
  AirLinkListItemWidget,
  AirListWidget,
  AirModalSectionWidget,
  AirNavbarWidget,
  AirOfferCardWidget,
  AirOfferContextualStripWidget,
  AirOfferListWidget,
  AirOfferPopupWidget,
  AirOfferStripWidget,
  AirOmniWidget,
  AirOrderSummaryCardWidget,
  AirOtpWidget,
  AirPackAmountWidget,
  AirPackCardWidget,
  AirPackDetailsListItemWidget,
  AirPackDetailsWidget,
  AirPageHeaderWidget,
  AirPayCategoryCardWidget,
  AirPlanDetailsWidget,
  AirPlanDetailsWithCarouselWidget,
  AirPlanListWidget,
  AirPriceBreakupWidget,
  AirPriceDetailWidget,
  AirQuickActionsCardWidget,
  AirQuickFilterWidget,
  AirRadioGroupWidget,
  AirReviewWidget,
  AirSchedulingWidget,
  AirScrollLinkListWidget,
  AirSelectionListWidget,
  AirServiceCardWidget,
  AirStatusCardWidget,
  AirStepCardSection,
  AirStepCardWidget,
  AirTabContainerWidget,
  AirTableWidget,
  AirTabsWidget,
  AirTaskCardWidget,
  AirTermsAndConditionWidget,
  AirTestimonialsWidget,
  AirTitleSection,
  AirToastWidget,
  AirTrackOrderCardWidget,
  AirTrackOrderIngressWidget,
  AirTrackOrderStepperWidget,
  AirTrackingDetailedWidget,
  AirTrustMarkerWidget,
  AirTypographyWidget,
  AirUploadFileWidget,
  AirUpsellNudgetWidget,
  AirVerticalFluidGridSection,
  AirCollapsibleSummaryCardWidget
};